export const PRODUCT_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft', badge: 'secondary' },
  { value: 'comingSoon', label: 'Coming Soon', badge: 'warning' },
  { value: 'active', label: 'Active', badge: 'success' },
];

export const getProductStatus = (product) => product?.status || 'active';
export const isProductPurchasable = (product) => getProductStatus(product) === 'active';
export const getProductStatusOption = (product) =>
  PRODUCT_STATUS_OPTIONS.find((option) => option.value === getProductStatus(product)) ||
  PRODUCT_STATUS_OPTIONS[2];
